export default __webpack_public_path__ + "static/media/Vector-user.942542a4.svg";